import React from "react";
import { Avatar, AvatarProps } from "antd";
import { colors } from "@libertify/ui";

export interface SquareIconProps extends Omit<AvatarProps, "shape" | "icon"> {
  /** What sits inside the square — a Phosphor icon, or a short text node such as
   *  a file extension ("PDF"). Passed straight to the underlying Avatar. */
  content: React.ReactNode;
}

export const SquareIcon: React.FC<SquareIconProps> = ({
  content,
  size = 44,
  style,
  ...rest
}) => (
  <Avatar
    shape="square"
    size={size}
    icon={content}
    style={{
      flexShrink: 0,
      background: colors.success[100],
      color: colors.success[500],
      ...style,
    }}
    {...rest}
  />
);

export default SquareIcon;
